import { Component, Input, ElementRef, Renderer2, HostListener, OnChanges } from '@angular/core';
import { ErrorMessageValidation } from '../../modeles/error-message-validation.modele';
import jump from 'jump.js';

@Component({
  selector: 'app-error-message-validation',
  templateUrl: './error-message-validation.component.html',
  styleUrls: ['./error-message-validation.component.scss'],
  standalone: false
})
export class ErrorMessageValidationComponent implements OnChanges {
  @Input()
  errors: Array<ErrorMessageValidation>;

  @Input()
  hasDivider = true;

  @Input()
  customMessage?: string;

  @Input()
  linkText?: string;

  @Input()
  linkRef?: string;

  constructor(private readonly _renderer: Renderer2, private readonly _el: ElementRef) {}

  ngOnChanges(): void {
    jump(this._el.nativeElement, {
      offset: -150,
      a11y: true
    });
  }

  @HostListener('focus') onFocus(): void {
    this._renderer.setStyle(this._el.nativeElement, 'outline', 'none');
  }
}
